import React,{Component} from "react";
import "../../../css/uilib/componentloader.css";

export default class ComponentLoader extends Component {
  render(){
    return(
      <div class="d-flex align-items-center justify-content-center componentloader ag-overlay-loading-center" >

  <figure></figure>
  <figure></figure>
  <figure></figure>
  <figure></figure>
  <figure></figure>

      </div>
    )
  }
}
